var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu_bar"},[_c('router-link',{staticClass:"router",attrs:{"to":_vm.path}},[_c('div',{staticClass:"vertical_align_div"},[_c('img',{staticClass:"nav_icon",attrs:{"src":_vm.icon}}),_vm._v("\n            "+_vm._s(_vm.title)+"\n        ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21fdb785","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/masterPanel/masterView/menubar.vue
// module id = null
// module chunks = 